// extracted by mini-css-extract-plugin
var _1 = "YvmjQ7LZNSzx9rHGJZVC";
var _2 = "IMEyW13Ohar6XLqV_yDm";
export { _1 as "colorLegend", _2 as "hint" }
